import Vue from "vue";
import VueTheMask from 'vue-the-mask'
import AwesomeMask from 'awesome-mask';
import * as VueGoogleMaps from 'vue2-google-maps'
import HighchartsVue from 'highcharts-vue'
import 'vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from 'vue-range-component'
import VueInputmask from './inputMaskPlugin'
import { Confirm } from 'notiflix/build/notiflix-confirm-aio';

require('./bootstrap');
require('./scripts');

window.Vue = require('vue').default;
window.Confirm = Confirm;

//import AwesomeMask from 'awesome-mask';
//import VueTheMask from 'vue-the-mask'

// import * as VueGoogleMaps from 'vue2-google-maps'

Vue.prototype.$eventBus = new Vue();

Vue.component('table-list', require('./components/table/ListComponent').default);
Vue.component('table-select-checkbox', require('./components/table/SelectCheckboxComponent').default);
Vue.component('table-filters-select', require('./components/table/filters/SelectComponent').default);

Vue.component('alert', require('./components/AlertComponent').default);

Vue.component('users-avatar-uploader', require('./components/users/AvatarUploaderComponent').default);
Vue.component('users-select', require('./components/UsersSelectComponent').default);
Vue.component('company-group-select', require('./components/CompanyGroupSelectComponent').default);

Vue.component('company-select', require('./components/CompanySelectComponent').default);

Vue.component('documents-file-upload', require('./components/documents/FileUploadComponent').default);

Vue.component('field-draw-map', require('./components/fields/FieldDrawMapComponent').default);
Vue.component('field-cropio-import', require('./components/fields/cropio/ImportComponent').default);

Vue.component('application-select-fields', require('./components/applications/ApplicationSelectFieldsComponent').default);
Vue.component('application-field-borders', require('./components/applications/ApplicationFieldBorders').default);

//simulator
Vue.component('simulator-container', require('./components/simulator/SimulatorContainerComponent').default);
Vue.component('crop-select', require('./components/simulator/CropSelectComponent').default);
Vue.component('region-select', require('./components/simulator/RegionSelectComponent').default);
Vue.component('meteo-points-map', require('./components/simulator/MeteoPointsMapComponent').default);
Vue.component('risk-period-select', require('./components/simulator/RiskPeriodSelectComponent').default);
Vue.component('limits', require('./components/simulator/LimitsComponent').default);
Vue.component('heat-days-chart', require('./components/simulator/HeatDaysChartComponent').default);
Vue.component('rain-days-chart', require('./components/simulator/RainDaysChartComponent').default);
Vue.component('weather-archive', require('./components/simulator/WeatherArchiveComponent').default);
Vue.component('insurance-coverage-chart', require('./components/simulator/InsuranceCoverageChartComponent').default);

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDs08lkrFILiiSW_s3sN0q14H8xJxvC5ZU',
        libraries: 'places,drawing,geometry',
    },
});

Vue.use(VueInputmask);

Vue.use(Confirm);

Vue.use(HighchartsVue);

Vue.use(VueRangeSlider);

Vue.component('google-map', VueGoogleMaps.Map);

const app = new Vue({
    el: '#app',
});
